import { getFetchUrl } from './get-fetch-url';
/**
 * @internal
 */
export var getFetchManyProductsUrl = function (entityIds, includeType) {
    var fetchUrl = getFetchUrl(entityIds, "p" /* Product */, includeType);
    var idReplacement = typeof entityIds[0] === 'number' ? 'pids=' : 'skus=';
    return fetchUrl.replace('ids=', idReplacement);
};
